<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24px"
        height="24px"
        style="fill: currentColor"
    >
        <path d="M13,6V18L21.5,12M4,18L12.5,12L4,6V18Z" />
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-fast-forward",
});
</script>
<style>
.enlarge-oss-fast-forward .v-btn__content {
    scale: 1.4;
    transform: translateX(4%);
}
</style>
